<template>
    <div id="nav-bar">
        <div class="row">
            <div class="col-4 text-center">
                <router-link to="/dashboard">
                    <font-awesome-icon icon="fa-solid fa-house" />
                    <div class="nav-text">Home</div>
                </router-link>
            </div>
            <div class="col-4 text-center">
                <router-link to="/manifest-courier">
                    <font-awesome-icon icon="fa-solid fa-rectangle-list" />
                    <div class="nav-text">Manifest Kurir</div>
                </router-link>
            </div>
            <div class="col-4 text-center">
                <div @click="action()">
                    <font-awesome-icon icon="fa-solid fa-door-open" />
                    <div class="nav-text">Logout</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'NavBar',
  data(){
     return {
        
     }
  },
  methods: {
    action(){
        this.$swal({
            title: 'Logout?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Iya',
            cancelButtonText: 'Tidak'
        }).then((result) => {
            if (result.isConfirmed) {
                this.$router.push('/')
                localStorage.removeItem('token')
                localStorage.removeItem('name')
                localStorage.removeItem('branch_code')
                localStorage.removeItem('virtual_account_no')
                localStorage.removeItem('virtual_account_name')
            }
        })
    }
  }
}
</script>
<style scoped>
#nav-bar{
    background:white;
    padding:10px;
    border-top:1px solid rgba(0,0,0,0.1);
    position:fixed;
    z-index:10;
    width:100%;
    bottom:0;
    color:#A61F69;
}
#nav-bar svg{
    font-size:2.5em;
    color:#A61F69;
}
.nav-text{
    color:#A61F69;
    font-size:1.3em;
}
.swal2-cancel{
    font-size:2em !important;
}
</style>
